import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  ReferenceManyField,
  SingleFieldList,
  ChipField,
  Filter,
  TextInput
} from 'admin-on-rest'

const StudentFilter = (props) => (
  <Filter {...props}>
      <TextInput label="Prenume" source="firstName" alwaysOn />
      <TextInput label="Nume" source="lastName" alwaysOn />
      <TextInput label="CNP" source="cnp" alwaysOn />
      <TextInput label="Telefon" source="phoneNumber" alwaysOn />
  </Filter>
);

export const AdminStudentsList = props => {
  return ( 
    <List {...props} title="Lista cursanti" filters={<StudentFilter />}>
    <Datagrid key="id">
      <TextField label="Prenume" source="firstName" />
      <TextField label="Nume" source="lastName" />
      <TextField label="Telefon" source="phoneNumber" />
      <TextField label="CNP" source="cnp" />
      <EmailField label="Email" source="email" />
      <TextField label="User ID" source="id" />
      <ReferenceManyField label="Cursuri" reference="courses" target="students">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceManyField>
    </Datagrid>
  </List>
) }



// WEBPACK FOOTER //
// ./src/admin/AdminStudentsList.js